// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"style-appWrapper-3Ihk9"};